import type {
	DataPoint,
	PercentDataPoint,
} from '@deezer/next/services/types/charts';
import type {Artist} from '@deezer/next/services/api/Starmania/requests/artist/types';
import type {Label} from '@deezer/next/services/types/label';
import type {Provider} from '@deezer/next/services/types/provider';

// TODO review if enums should be here or not

export enum StakeholderType {
	LABEL = 'Label',
	MANAGER = 'Manager',
	PROVIDER = 'Provider',
	ARTIST = 'Artist',
}

export enum TimePeriod {
	LAST_7_DAYS = 'last7Days',
	LAST_30_DAYS = 'last30Days',
	LAST_YEAR = 'lastYear',
}

export enum OfferType {
	subs = 'subs',
	free = 'free',
	all = 'all',
}

export enum DemographicType {
	age = 'age',
	gender = 'gender',
	platform = 'platform',
	countries = 'top-countries',
}

export type VerifyOwnershipResponse = {
	message: string;
};

export type VerifyLabelOwnershipResponse = {
	data: {
		message: string;
		id: number;
	};
};

export type Album = {
	id: number;
	name: string;
	picture: string;
	artists: Artist[];
	upc: string;
	redirectUrl?: string | null;
	label: Label | null;
	provider: Provider | null;
};

export type AlbumPerformances = {
	title: string;
	streams: number;
	listeners: number;
};

export type AlbumDemographics = {
	genders: PercentDataPoint[];
	offers: PercentDataPoint[];
	ages: PercentDataPoint[];
	devices: PercentDataPoint[];
};

export type AlbumDemographic = PercentDataPoint[];

export type AlbumFansEvolution = {
	timePeriod: TimePeriod;
	fans: {
		total: number;
		timeseries: DataPoint[];
	};
};

export enum AlbumStatus {
	LIVE = 1,
	TAKEDOWN = 0,
}

export enum ReleaseType {
	ALBUM = 'album',
	EP = 'ep',
	SINGLE = 'single',
}

export enum ReleaseTypeNumber {
	SINGLE = 0,
	ALBUM = 1,
	COMPILATION = 2,
	EP = 3,
}

export type Release = {
	id: number;
	picture: string;
	title: string;
	releaseDate: string;
	providerName: string;
	labelName: string;
	url: string;
	upc: string;
	type: ReleaseType;
	status: AlbumStatus;
};
